<app-navbar title="Dodawanie wydarzenia transportowego">
	<button class="btn btn-primary me-2" (click)="submit()">Zapisz</button>
	<a routerLink="/tourism-calendar/" class="btn btn-danger"> <i class="far fa-calendar-alt"></i> Kalendarz </a>
</app-navbar>

<div class="container">
	<form class="my-4">
		<div class="form-floating mb-3">
			<input
				class="form-control"
				id="name"
				name="name"
				[(ngModel)]="event.name"
				[ngClass]="{ error: this.errors.name }"
			/>
			<label for="name">Nazwa wydarzenia</label>
		</div>
		<div class="row mb-3">
			<div class="col-4">
				<div class="form-floating">
					<input
						type="datetime-local"
						class="form-control"
						name="date_from"
						id="date_from"
						[ngModel]="event.date_from | date: 'yyyy-MM-ddTHH:mm'"
						(ngModelChange)="
							event.date_from = $event;
							calculateDateTo();
							calculateDatePrepare();
							calculateDateDeadline();
							calculateStartDate();
							calculateDateAuto()
						"
						[ngClass]="{ error: this.errors.date_from }"
					/>
					<label for="date_from">Data rozpoczęcia</label>
				</div>
			</div>
			<div class="col-4">
				<div class="form-floating">
					<input
						type="datetime-local"
						class="form-control"
						name="date_to"
						id="date_to"
						[ngModel]="event.date_to | date: 'yyyy-MM-ddTHH:mm'"
						(ngModelChange)="
							event.date_to = $event; calculateDateDeadline(); calculateDateAuto(); calculateEndDate()
						"
						[ngClass]="{ error: this.errors.date_to }"
					/>
					<label for="date_to">Data zakończenia</label>
				</div>
			</div>
			<div class="col-4">
				<div class="form-floating">
					<input
						type="datetime-local"
						class="form-control"
						name="date_deadline"
						id="date_deadline"
						[ngModel]="event.date_deadline | date: 'yyyy-MM-ddTHH:mm'"
						(ngModelChange)="event.date_deadline = $event"
						[readonly]="event.dateDeadlineAuto"
					/>
					<label for="date_deadline">Data potwierdzenia</label>
				</div>
				<div class="form-check mb-3">
					<input
						class="form-check-input"
						type="checkbox"
						name="dateDeadlineAuto"
						[(ngModel)]="event.dateDeadlineAuto"
						id="dateDeadlineAuto"
						(change)="calculateDateDeadline()"
						[disabled]="!auth.permissionsByCode()[Permissions.VEHICLES_EVENTS_DISABLE_AUTO_DATES_CONFIRMS]"
					/>
					<label class="form-check-label" for="dateDeadlineAuto"> Automatyczna data potwierdzenia </label>
				</div>
			</div>
		</div>
		<div class="form-floating mb-3">
			<input
				type="text"
				class="form-control"
				name="calculation_link"
				id="calculation_link"
				[(ngModel)]="event.calculation_link"
			/>
			<label for="calculation_link">Link do kalkulacji</label>
		</div>
		<div class="form-floating mb-3">
			<select class="form-select" id="status" name="status" [(ngModel)]="event.status">
				<option value="{{ item.id }}" *ngFor="let item of statuses">
					{{ item.name }}
				</option>
			</select>
			<label for="status">Status</label>
		</div>
		<div
			class="row align-items-center"
			*ngIf="
				event.category === 'RENT' ||
				event.category === 'GROUP' ||
				event.category === 'FOREIGN_SCANDINAVIA' ||
				event.category === 'FOREIGN'
			"
		>
			<div class="col-6">
				<div class="form-floating mb-3">
					<input
						type="number"
						step="1"
						min="0"
						class="form-control"
						id="people"
						name="people"
						[(ngModel)]="event.people"
						[ngClass]="{ error: this.errors.people }"
						required
					/>
					<label for="people">Planowana ilość osób</label>
				</div>
			</div>
			<div class="col-6">
				<div class="form-check mb-3">
					<input
						class="form-check-input"
						type="checkbox"
						name="people_confirmed"
						[(ngModel)]="event.people_confirmed"
						id="people_confirmed"
					/>
					<label class="form-check-label" for="people_confirmed"> Ilość osób jest potwierdzona </label>
				</div>
			</div>
		</div>
		<div class="mb-3">
			<app-tourism-events-vehicle-add
				[min]="event.date_from"
				[max]="event.date_to"
				[vehicles]="vehicles"
				[editable]="lockEdit"
				[alreadyAddedVehicles]="event.vehicles"
				(emitVehiclesArray)="setVehicles($event); addDriversAuto()"
			></app-tourism-events-vehicle-add>
		</div>
		<div class="mb-3">
			<label class="form-label" for="owner">Opiekun</label>
			<ng-select
				id="owner"
				name="owner"
				[(ngModel)]="event.owner"
				placeholder="(wybierz)"
				bindLabel="name"
				[multiple]="true"
				[ngClass]="{ error: this.errors.owner }"
				required
			>
				<ng-option *ngFor="let item of users" [value]="item.id">{{ item.name }}</ng-option>
			</ng-select>
		</div>
		<div class="row mb-3">
			<div class="col-3">
				<div class="form-floating">
					<input
						type="text"
						class="form-control"
						name="startPlace"
						id="startPlace"
						[(ngModel)]="event.startPlace"
						(change)="startPlaceChanged()"
						[ngClass]="{ error: this.errors.startPlace }"
						required
					/>
					<label for="startPlace">Miejsce podstawienia (dokładny adres)</label>
				</div>
			</div>
			<div class="col-3">
				<div class="form-floating mb-3">
					<input
						type="text"
						class="form-control"
						name="startPostCode"
						id="startPostCode"
						[(ngModel)]="event.startPostCode"
						(change)="startPlaceChanged()"
					/>
					<label for="startPostCode">Kod pocztowy</label>
				</div>
			</div>
			<div class="col-3">
				<div class="form-floating">
					<input
						type="datetime-local"
						class="form-control"
						name="startDate"
						id="startDate"
						[ngModel]="event.startDate | date: 'yyyy-MM-ddTHH:mm'"
						[ngClass]="{ error: this.errors.startDate }"
						(ngModelChange)="event.startDate = $event"
					/>
					<label for="startDate">Data podstawienia</label>
				</div>
			</div>
			<div class="col-3">
				<button
					class="btn"
					[ngClass]="{
						'btn-success': event.departure_place_confirmed,
						'btn-outline-danger': !event.departure_place_confirmed,
					}"
					(click)="event.departure_place_confirmed = !event.departure_place_confirmed"
				>
					Potwierdzone
				</button>
			</div>
		</div>
		<div class="mb-3">
			<label class="form-label" for="programWyjazdu">Program wyjazdu</label>
			<ckeditor
				id="programWyjazdu"
				name="programWyjazdu"
				[(ngModel)]="event.text_program"
				[editor]="editor"
				[config]="editorConfig"
			></ckeditor>
		</div>
		<div class="row mb-3">
			<div class="col-4">
				<button
					class="btn"
					[ngClass]="{
						'btn-success': event.detail_about_first_day_confirmed,
						'btn-outline-danger': !event.detail_about_first_day_confirmed,
					}"
					(click)="event.detail_about_first_day_confirmed = !event.detail_about_first_day_confirmed"
				>
					Szczegóły dot. pierwszego dnia
				</button>
			</div>
			<div class="col-4">
				<button
					class="btn"
					[ngClass]="{
						'btn-success': event.detail_about_program_confirmed,
						'btn-outline-danger': !event.detail_about_program_confirmed,
					}"
					(click)="event.detail_about_program_confirmed = !event.detail_about_program_confirmed"
				>
					Program jest szczegółowy
				</button>
			</div>
			<div class="col-4">
				<button
					class="btn"
					[ngClass]="{
						'btn-success': event.detail_about_last_day_confirmed,
						'btn-outline-danger': !event.detail_about_last_day_confirmed,
					}"
					(click)="event.detail_about_last_day_confirmed = !event.detail_about_last_day_confirmed"
				>
					Szczegóły dot. ostatniego dnia
				</button>
			</div>
		</div>
		<div class="row mt-5">
			<div class="col-3">
				<div class="form-floating mb-3">
					<input
						type="text"
						class="form-control"
						name="endPlace"
						id="endPlace"
						[ngClass]="{
							error: this.errors.endPlace,
						}"
						[(ngModel)]="event.endPlace"
					/>
					<label for="endPlace">Miejsce odstawienia (dokładny adres)</label>
				</div>
			</div>
			<div class="col-3">
				<div class="form-floating mb-3">
					<input
						type="text"
						class="form-control"
						name="endPostCode"
						id="endPostCode"
						[(ngModel)]="event.endPostCode"
					/>
					<label for="endPostCode">Kod pocztowy</label>
				</div>
			</div>
			<div class="col-3">
				<div class="form-floating mb-3">
					<input
						type="datetime-local"
						class="form-control"
						name="endDate"
						id="endDate"
						[ngModel]="event.endDate | date: 'yyyy-MM-ddTHH:mm'"
						[ngClass]="{
							error: this.errors.endDate,
						}"
						(ngModelChange)="event.endDate = $event"
					/>
					<label for="endDate">Data odstawienia</label>
				</div>
			</div>

			<div class="col-3">
				<button
					class="btn"
					[ngClass]="{
						'btn-success': event.return_place_confirmed,
						'btn-outline-danger': !event.return_place_confirmed,
					}"
					(click)="event.return_place_confirmed = !event.return_place_confirmed"
				>
					Potwierdzone
				</button>
			</div>
		</div>
		<div class="mb-3 col-6">
			<h6>Klient</h6>
			<app-tourism-events-organization
				[client]="event.client"
				(clientData)="sendData($event)"
			></app-tourism-events-organization>
		</div>
		<div class="mb-3">
			<div class="form-floating">
				<textarea
					class="form-control"
					id="client_wishes"
					name="client_wishes"
					[(ngModel)]="event.client_wishes"
				></textarea>
				<label for="client_wishes">Wymagania klienta i świadczenia</label>
			</div>
		</div>
		<div class="card mb-3">
			<div class="card mb-3">
				<div class="card-body">
					<div class="row col-7">
						<div class="col">
							<label class="form-label text-start">Kierowcy wyjazd</label>
						</div>
					</div>
					<div class="row mt-2" *ngFor="let driver of event.drivers_departure; let driverIndex = index">
						<div class="col">
							<label for="program_date_from">Kierowca</label>
							<ng-select
								name="driversDeparture_{{ driverIndex }}"
								[(ngModel)]="event.drivers_departure[driverIndex].driver"
								placeholder="(wybierz)"
								bindLabel="name"
								[disabled]="lockEdit || driver?.confirmed"
								(change)="
									checkConfirmSalaryDrivers(driver);
									checkEditedDriverDocument(event);
									changeDriver(driver)
								"
								(focus)="onFocusedDriver(event.drivers_departure[driverIndex].driver)"
							>
								<ng-option *ngFor="let item of drivers" [value]="item.id"
									>{{ item.last_name }} {{ item.first_name }}</ng-option
								>
							</ng-select>
							<a class="cursor-pointer" (click)="driverModalOpen(driver)" *ngIf="lockEdit"
								>Czas pracy kierowcy</a
							>
						</div>
						<div class="col">
							<label for="drivers_departure_{{ driverIndex }}_date_from">Data od</label>
							<input
								type="datetime-local"
								class="col-sm-2 form-control"
								name
								name="drivers_departure_{{ driverIndex }}_date_from"
								id="drivers_departure_{{ driverIndex }}_date_from"
								[ngModel]="driver.date_from | date: 'yyyy-MM-ddTHH:mm'"
								(ngModelChange)="driver.date_from = $event"
								(change)="checkEditedDriverDocument(event)"
								[readonly]="driver.dateFromAuto"
								[disabled]="lockEdit || driver?.confirmed"
							/>
							<div class="col form-check mt-1">
								<input
									class="form-check-input"
									type="checkbox"
									[(ngModel)]="driver.dateFromAuto"
									(change)="autoDate('drivers_departure', driver, 'dateFromAuto', 'date_from')"
									name="drivers_departure_{{ driverIndex }}_dateFromAuto"
									id="drivers_departure_{{ driverIndex }}_dateFromAuto"
									[disabled]="lockEdit || driver?.confirmed"
								/>
								<label class="form-check-label" for="drivers_departure_{{ driverIndex }}_dateFromAuto">
									Automatyczna "Data od"
								</label>
							</div>
						</div>
						<div class="col">
							<label for="drivers_departure_{{ driverIndex }}_date_to">Data do</label>
							<input
								type="datetime-local"
								class="col-sm-2 form-control"
								name="drivers_departure_{{ driverIndex }}_date_to"
								id="drivers_departure_{{ driverIndex }}_date_to"
								[ngModel]="driver.date_to | date: 'yyyy-MM-ddTHH:mm'"
								(ngModelChange)="driver.date_to = $event"
								(change)="checkEditedDriverDocument(event)"
								[readonly]="driver.dateToAuto"
								[disabled]="lockEdit || driver?.confirmed"
							/>
							<div class="col form-check mt-1">
								<input
									class="form-check-input"
									type="checkbox"
									[(ngModel)]="driver.dateToAuto"
									(change)="autoDate('drivers_departure', driver, 'dateToAuto', 'date_to')"
									name="drivers_departure_{{ driverIndex }}_dateToAuto"
									id="drivers_departure_{{ driverIndex }}_dateToAuto"
									[disabled]="lockEdit || driver?.confirmed"
								/>
								<label class="form-check-label" for="drivers_departure_{{ driverIndex }}_dateToAuto">
									Automatyczna "Data do"
								</label>
							</div>
						</div>
						<div class="col">
							<div
								class="btn btn-danger mt-4"
								(click)="deleteDriver('drivers_departure', driver)"
								*ngIf="!driver.confirmed && !lockEdit"
							>
								Usuń kierowce
							</div>
							<div class="mt-4">
								<a
									target="_blank"
									routerLink="/drivers-calendar/{{ driver.date_from | date: 'yyyy-MM-dd' }}"
									[fragment]="driver.driver"
									*ngIf="lockEdit"
								>
									<i class="far fa-calendar-alt"></i>
								</a>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col mt-2">
							<div class="btn btn-primary" (click)="driverAddRow('drivers_departure')" *ngIf="!lockEdit">
								Dodaj kierowce
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card mb-3">
				<div class="card-body">
					<div class="row col-7">
						<div class="col">
							<label class="form-label text-start">Kierowcy program</label>
						</div>
					</div>
					<div class="row mt-2" *ngFor="let driver of event.drivers_program; let driverIndex = index">
						<div class="col-sm-3">
							<label for="program_date_from">Kierowca</label>
							<ng-select
								name="driversProgram_{{ driverIndex }}"
								[(ngModel)]="event.drivers_program[driverIndex].driver"
								placeholder="(wybierz)"
								bindLabel="name"
								[disabled]="lockEdit"
								[ngClass]="{ error: this.errors.name }"
								[disabled]="lockEdit || driver?.confirmed"
								(change)="
									checkConfirmSalaryDrivers(driver);
									checkEditedDriverDocument(event);
									changeDriver(driver)
								"
								(focus)="onFocusedDriver(event.drivers_program[driverIndex].driver)"
							>
								<ng-option *ngFor="let item of drivers" [value]="item.id"
									>{{ item.last_name }} {{ item.first_name }}</ng-option
								>
							</ng-select>
							<a class="cursor-pointer" (click)="driverModalOpen(driver)" *ngIf="lockEdit"
								>Czas pracy kierowcy</a
							>
						</div>
						<div class="col">
							<label for="drivers_program_{{ driverIndex }}_date_from">Data od</label>
							<input
								type="datetime-local"
								class="col-sm-2 form-control"
								name="drivers_program_{{ driverIndex }}_date_from"
								id="drivers_program_{{ driverIndex }}_date_from"
								[ngModel]="driver.date_from | date: 'yyyy-MM-ddTHH:mm'"
								(ngModelChange)="driver.date_from = $event"
								(change)="checkEditedDriverDocument(event)"
								[readonly]="driver.dateFromAuto"
								[disabled]="lockEdit || driver?.confirmed"
							/>
							<div class="col form-check mt-1">
								<input
									class="form-check-input"
									type="checkbox"
									[(ngModel)]="driver.dateFromAuto"
									(change)="autoDate('drivers_program', driver, 'dateFromAuto', 'date_from')"
									name="drivers_program_{{ driverIndex }}_dateFromAuto"
									id="drivers_program_{{ driverIndex }}_dateFromAuto"
									[disabled]="lockEdit || driver?.confirmed"
								/>
								<label class="form-check-label" for="drivers_program_{{ driverIndex }}_dateFromAuto">
									Automatyczna "Data od"
								</label>
							</div>
						</div>
						<div class="col">
							<label for="drivers_program_{{ driverIndex }}_date_to">Data do</label>
							<input
								type="datetime-local"
								class="col-sm-2 form-control"
								name="drivers_program_{{ driverIndex }}_date_to"
								id="drivers_program_{{ driverIndex }}_date_to"
								[ngModel]="driver.date_to | date: 'yyyy-MM-ddTHH:mm'"
								(ngModelChange)="driver.date_to = $event"
								(change)="checkEditedDriverDocument(event)"
								[readonly]="driver.dateToAuto"
								[disabled]="lockEdit || driver?.confirmed"
							/>
							<div class="col form-check mt-1">
								<input
									class="form-check-input"
									type="checkbox"
									[(ngModel)]="driver.dateToAuto"
									(change)="autoDate('drivers_program', driver, 'dateToAuto', 'date_to')"
									name="drivers_program_{{ driverIndex }}_dateToAuto"
									id="drivers_program_{{ driverIndex }}_dateToAuto"
									[disabled]="lockEdit || driver?.confirmed"
								/>
								<label class="form-check-label" for="drivers_program_{{ driverIndex }}_dateToAuto">
									Automatyczna "Data do"
								</label>
							</div>
						</div>
						<div class="col">
							<div
								class="btn btn-danger mt-4"
								(click)="deleteDriver('drivers_program', driver)"
								*ngIf="!driver.confirmed && !lockEdit"
							>
								Usuń kierowce
							</div>
							<div class="mt-4">
								<a
									target="_blank"
									routerLink="/drivers-calendar/{{ driver.date_from | date: 'yyyy-MM-dd' }}"
									[fragment]="driver.driver"
									*ngIf="lockEdit"
								>
									<i class="far fa-calendar-alt"></i>
								</a>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col mt-2">
							<div class="btn btn-primary" (click)="driverAddRow('drivers_program')" *ngIf="!lockEdit">
								Dodaj kierowce
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="card-body">
				<div class="row col-7">
					<div class="col">
						<label class="form-label text-start">Kierowcy powrót</label>
					</div>
				</div>
				<div class="row mt-2" *ngFor="let driver of event.drivers_return; let driverIndex = index">
					<div class="col-sm-3">
						<label for="program_date_from">Kierowca</label>
						<ng-select
							name="driversReturn_{{ driverIndex }}"
							(change)="
								checkConfirmSalaryDrivers(driver);
								checkEditedDriverDocument(event);
								changeDriver(driver)
							"
							(focus)="onFocusedDriver(event.drivers_return[driverIndex].driver)"
							[(ngModel)]="event.drivers_return[driverIndex].driver"
							placeholder="(wybierz)"
							bindLabel="name"
							[disabled]="lockEdit"
						>
							<ng-option *ngFor="let item of drivers" [value]="item.id"
								>{{ item.last_name }} {{ item.first_name }}</ng-option
							>
						</ng-select>
						<a class="cursor-pointer" (click)="driverModalOpen(driver)" *ngIf="lockEdit"
							>Czas pracy kierowcy</a
						>
					</div>
					<div class="col">
						<label for="drivers_return_{{ driverIndex }}_date_from">Data od</label>
						<input
							type="datetime-local"
							class="col-sm-2 form-control"
							name="drivers_return_{{ driverIndex }}_date_from"
							id="drivers_return_{{ driverIndex }}_date_from"
							[ngModel]="driver.date_from | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="driver.date_from = $event"
							(change)="checkEditedDriverDocument(event)"
							[readonly]="driver.dateFromAuto"
							[disabled]="lockEdit || driver?.confirmed"
						/>
						<div class="col form-check mt-1">
							<input
								class="form-check-input"
								type="checkbox"
								[(ngModel)]="driver.dateFromAuto"
								(change)="autoDate('drivers_return', driver, 'dateFromAuto', 'date_from')"
								name="drivers_return_{{ driverIndex }}_dateFromAuto"
								id="drivers_return_{{ driverIndex }}_dateFromAuto"
								[disabled]="lockEdit || driver?.confirmed"
							/>
							<label class="form-check-label" for="drivers_return_{{ driverIndex }}_dateFromAuto">
								Automatyczna "Data od"
							</label>
						</div>
					</div>
					<div class="col">
						<label for="drivers_return_{{ driverIndex }}_date_to">Data do</label>
						<input
							type="datetime-local"
							class="col-sm-2 form-control"
							name="drivers_return_{{ driverIndex }}_date_to"
							id="drivers_return_{{ driverIndex }}_date_to"
							[ngModel]="driver.date_to | date: 'yyyy-MM-ddTHH:mm'"
							(ngModelChange)="driver.date_to = $event"
							(change)="checkEditedDriverDocument(event)"
							[readonly]="driver.dateToAuto"
							[disabled]="lockEdit || driver?.confirmed"
						/>
						<div class="col form-check mt-1">
							<input
								class="form-check-input"
								type="checkbox"
								[(ngModel)]="driver.dateToAuto"
								(change)="autoDate('drivers_return', driver, 'dateToAuto', 'date_to')"
								name="drivers_return_{{ driverIndex }}_dateToAuto"
								id="drivers_return_{{ driverIndex }}_dateToAuto"
								[disabled]="lockEdit || driver?.confirmed"
							/>
							<label class="form-check-label" for="drivers_return_{{ driverIndex }}_dateToAuto">
								Automatyczna "Data do"
							</label>
						</div>
					</div>
					<div class="col">
						<div
							class="btn btn-danger mt-4"
							(click)="deleteDriver('drivers_return', driver)"
							*ngIf="!driver.confirmed && !lockEdit"
						>
							Usuń kierowce
						</div>
						<div class="mt-4">
							<a
								target="_blank"
								routerLink="/drivers-calendar/{{ driver.date_from | date: 'yyyy-MM-dd' }}"
								[fragment]="driver.driver"
								*ngIf="lockEdit"
							>
								<i class="far fa-calendar-alt"></i>
							</a>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col mt-2">
						<div class="btn btn-primary" (click)="driverAddRow('drivers_return')" *ngIf="!lockEdit">
							Dodaj kierowce
						</div>
					</div>
				</div>
			</div>
		</div>
	</form>
</div>
<br />
